<script setup lang="ts">
import { Button } from '@/lib/ui/button'
import siddFaceSvg from '@app/assets/sidd-face.svg'

interface IWebDirectLoginProps {
  readonly logoUrl?: string
  readonly name?: string
}

interface IWebDirectLoginEmits {
  login: []
}

defineProps<IWebDirectLoginProps>()
const emit = defineEmits<IWebDirectLoginEmits>()
</script>

<template>
  <div class="wd-login-bg flex items-center justify-center min-h-dvh p-6">
    <div class="wd-login-overlay" aria-hidden="true" />

    <div
      class="relative z-10 flex flex-col items-center gap-8 w-full max-w-xs"
      role="main"
      aria-label="Login"
    >
      <div
        class="wd-login-card w-full flex flex-col items-center gap-6 rounded-2xl p-8"
      >
        <img :src="logoUrl ?? siddFaceSvg" alt="Logo" class="h-14 w-auto" />

        <div class="text-center flex flex-col gap-2">
          <h1 class="text-xl font-semibold text-foreground">
            {{ name ? `Welcome to ${name}` : 'Welcome back' }}
          </h1>
          <p class="text-sm text-muted-foreground leading-relaxed">
            Sign in to access your AI assistant
          </p>
        </div>

        <Button
          class="w-full"
          size="lg"
          aria-label="Sign in to access this chatbot"
          @click="emit('login')"
        >
          Sign In
        </Button>
      </div>

      <p class="text-xs text-white/60">
        Powered by <span class="font-medium text-white/80">Sidd</span>
      </p>
    </div>
  </div>
</template>

<style scoped>
.wd-login-bg {
  background-image: url('@app/assets/keycloak-bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.wd-login-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    hsl(var(--primary) / 0.55) 0%,
    hsl(222 47% 11% / 0.75) 100%
  );
}

.wd-login-card {
  background-color: hsl(var(--background) / 0.9);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow:
    0 20px 40px hsl(0 0% 0% / 0.2),
    0 1px 0 hsl(var(--border) / 0.5) inset;
}
</style>
